import { createContext, useState, useContext, useMemo } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { MAIN_PALLETE } from "../constants/colorConfig";

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeContextProvider");
  }
  return context;
};

export const ThemeContextProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(true);

  const toggleTheme = () => {
    setDarkMode((prev) => !prev);
  };

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: darkMode ? "dark" : "light",
          primary: {
            main: MAIN_PALLETE.MEDIUM_BLUE,
            light: MAIN_PALLETE.LIGHT_BLUE,
            dark: MAIN_PALLETE.DARK_BLUE,
          },
          secondary: {
            main: MAIN_PALLETE.ADD_GREEN,
          },
          background: {
            default: darkMode ? MAIN_PALLETE.DARK_OUTLINE : MAIN_PALLETE.LIGHT_GREY,
            paper: darkMode ? MAIN_PALLETE.MAIN_BACKGROUND : MAIN_PALLETE.WHITE,
          },
          text: {
            primary: darkMode ? MAIN_PALLETE.WHITE : MAIN_PALLETE.BLACK,
            secondary: darkMode ? MAIN_PALLETE.LIGHT_GREY : MAIN_PALLETE.MAIN_GREY,
          },
        },
        components: {
          MuiPaper: {
            styleOverrides: {
              root: {
                backgroundImage: "none",
              },
            },
          },
          MuiTableCell: {
            styleOverrides: {
              root: {
                borderColor: darkMode ? MAIN_PALLETE.SECONDARY_BACKGROUND : MAIN_PALLETE.MAIN_GREY,
              },
            },
          },
        },
      }),
    [darkMode]
  );

  const value = {
    darkMode,
    toggleTheme,
    theme,
  };

  return (
    <ThemeContext.Provider value={value}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
